module.exports = __webpack_public_path__ + "static/media/twitter.a80b505a.svg";